import {IStation, StationBehaviorType, StationStatusType} from '@core/api/data-access';
import {StationUserModel} from './station-user.model';

export class StationModel implements IStation {
	name = '';
	ordinal = NaN;

	status: StationStatusType = undefined;
	behavior: StationBehaviorType = StationBehaviorType.FirstAction;

	fields: number[] = [];
	users: StationUserModel[] = [];

	runParallel = 0;

	/* ----------------- Conditions ----------------- */
	conditions: string[] = [];

	/* ----------------------------------------------  Constructor ---------------------------------------------- */
	constructor(init: Partial<IStation>) {
		Object.assign(this, init);
		if (this.users?.length) {
			this.users = this.users.map(user => new StationUserModel(user));
		}
	}

	public getAllUserIds(): string[] {
		return this.users.map(user => user.user);
	}

	toJSON(): IStation {
		return {
			name: this.name,
			ordinal: this.ordinal,
			status: this.status,
			behavior: this.behavior,
			users: this.users.map(user => user.toJSON()),
			fields: this.fields,
			conditions: this.conditions,
			runParallel: this.runParallel,
		};
	}
}
